<template>
  <v-autocomplete
    :key="key"
    v-model:search="search"
    :hide-no-data="!search"
    :model-value="modelValue"
    :label="t('selectGroup.group')"
    :items="items"
    clearable
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #no-data>
      <v-list-item @click="addGroup(search)">
        {{ t("selectGroup.createGroup", { name: search }) }}
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import { useCollection } from "@/composables/useFirestore";
import { useI18n } from "@/composables/useI18n";
import { db } from "@/firebase";
import { useUserStore } from "@/store";
import type { SupervisorOrgGroup } from "@aircap/common/supervisorOrg";
import { supervisorOrgGroupsFullPath } from "@aircap/common/supervisorOrg";
import { collection } from "firebase/firestore";
import { computed, ref } from "vue";

const props = defineProps<{
  modelValue: string | null;
  newGroupName: string | null;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: string | null];
  "update:newGroupName": [value: string | null];
}>();

const { t } = useI18n();
const user = useUserStore();
const search = ref("");

const key = ref(0);

const collectionSource = computed(() =>
  user.supervisorOrgId
    ? collection<SupervisorOrgGroup>(db, supervisorOrgGroupsFullPath(user.supervisorOrgId))
    : null,
);
const groups = useCollection<SupervisorOrgGroup>(collectionSource);

const items = computed(() => {
  return [
    ...groups.value.map((group) => ({ title: group.name, value: group.id })),
    ...(props.newGroupName ? [{ title: props.newGroupName, value: "new" }] : []),
  ];
});

const addGroup = (name: string) => {
  emit("update:modelValue", "new");
  emit("update:newGroupName", name);
  key.value++;
};
</script>
